<template>
  <div class="box">
    <div class="header">
      <div class="header-content">
        <div class="back" @click="onClickLeft">
          <img src="../assets/back.png" style="width: 1.4rem;height:1.4rem" />
        </div>
        <span class="welMsg2">加入鹊桥会</span>
      </div>
      <div class="header-alert">
        <span class="infoBox1">
          1.&nbsp;非常欢迎您加入我们{{ COMPANYNAME }}鹊桥会； <br />2.&nbsp;{{
            COMPANYNAME
          }}鹊桥会，隶属于{{
            ChineseCOMPANYNAME
          }}工会，作为官方指定的唯一组织，为内部单身男女同事扩大朋友圈，促成良缘，为{{
            COMPANYNAME == "ATL" ? "集团宁德区域" : ""
          }}稳定人才起到积极推进作用；
          <br />3.鹊桥会欢迎每一位有缘人：
          <br />&nbsp;&nbsp;&nbsp;&nbsp;男生：公司内部F4及以上可注册（暂未向公司外男生开放）；
          <br />&nbsp;&nbsp;&nbsp;&nbsp;女生：各企事业单位及公司内部全体女生均可注册。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;期待在这里遇见美好的你！
          <br />4.&nbsp;我们提倡诚信交友，请您确保以下填写内容真实有效，如有虚假信息须承担相关法律责任；
          <br />5.&nbsp;为了创建更完善的交友及公众平台环境，并且能够更高效、更精准的为您提供服务，请您耐心填写如下内容，我们保证对您提供的信息予以保密；
          <br />6.&nbsp;如有任何疑问，欢迎联系鹊桥会官方电话{{ TEL }}(微信同号)
        </span>
      </div>
    </div>
    <div class="content-introduce">
      <div class="form-tabs">
        <button type="button" class="tab-btn" :class="{ active: activeTab === 'basic' }" @click="activeTab = 'basic'">
          基础信息
        </button>
        <button type="button" class="tab-btn" :class="{ active: activeTab === 'spouse' }" @click="activeTab = 'spouse'">
          择偶要求
        </button>
      </div>
      <van-form ref="infoForm">
        <template v-if="activeTab === 'basic'">
          <!-- 头像上传 -->
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(1) }}.上传头像（必填）</van-col>
          </van-row>
          <div class="avatar-upload-container">
            <div class="avatar-preview">
              <img v-if="info.avatarLink" :src="info.avatarLink" class="avatar-img" />
              <van-icon v-else name="photograph" size="2rem" class="avatar-placeholder" />
            </div>
            <van-uploader accept="image/*" :before-read="onSelectAvatar">
              <van-button size="small" type="primary" native-type="button" class="avatar-upload-btn">选择头像</van-button>
            </van-uploader>
            <div class="avatar-tip">建议使用本人真实1:1尺寸照片</div>
          </div>
          <van-row class="van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(2) }}.单位类型</van-col>
          </van-row>
          <van-radio-group v-model="info.isAtl" :disabled="disabled">
            <van-radio name="1" icon-size="0.6rem">本公司</van-radio>
            <van-radio name="2" icon-size="0.6rem">外单位</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between" v-if="['', '1'].includes(info.isAtl)">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(3) }}.工号（外部人员请填写"无")</van-col>
          </van-row>
          <van-field v-model="info.employeeNo" v-if="['', '1'].includes(info.isAtl)" @change="employeeNoChange" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(4) }}.公司名称（外单位请填写全称）</van-col>
          </van-row>
          <van-field v-model="info.companyName" :disabled="disabled" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(5) }}.所在部门</van-col>
          </van-row>
          <van-field v-model="info.department" :disabled="disabled" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(6) }}.入职日期</van-col>
          </van-row>
          <van-field v-model="info.entryDate" readonly @click="handleShowPop('entryDateShow', disabled)" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(7) }}.岗位名称</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem;">填写名称，例财务主管等</span>
          <van-field v-model="info.positionTitle" :disabled="disabled" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(8) }}.姓名</van-col>
          </van-row>
          <van-field v-model="info.name" :disabled="disabled" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(9) }}.昵称</van-col>
          </van-row>
          <van-field v-model="info.nickName" placeholder="请输入昵称" maxlength="20" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(10) }}.性别</van-col>
          </van-row>
          <van-radio-group v-model="info.sex" :disabled="disabled">
            <van-radio :disabled="info.isAtl === '2'" name="1" icon-size="0.6rem">男</van-radio>
            <van-radio name="2" icon-size="0.6rem">女</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(11) }}.出生日期</van-col>
          </van-row>
          <van-field v-model="info.birthday" :disabled="disabled" readonly @click="handleShowPop('birthDateShow', disabled)" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(12) }}.籍贯</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem;">例xx省xx市</span>
          <van-field v-model="info.hometown" readonly @click="handleShowPop('areaCheck', false)" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(13) }}.身高（CM）</van-col>
          </van-row>
          <van-field v-model="info.height" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(14) }}.体重（KG）</van-col>
          </van-row>
          <van-field v-model="info.weight" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(15) }}.民族</van-col>
          </van-row>
          <van-field v-model="info.nation" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(16) }}.学历</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem;">最高学历</span>
          <van-radio-group v-model="info.education" :disabled="disabled">
            <van-radio name="1" icon-size="0.6rem">大专</van-radio>
            <van-radio name="2" icon-size="0.6rem">本科</van-radio>
            <van-radio name="3" icon-size="0.6rem">硕士</van-radio>
            <van-radio name="4" icon-size="0.6rem">博士</van-radio>
            <van-radio name="5" icon-size="0.6rem">高中及以下</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(17) }}.毕业学校名称</van-col>
          </van-row>
          <van-field v-model="info.graduateSchool" :disabled="disabled" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(18) }}.婚姻状态</van-col>
          </van-row>
          <van-radio-group v-model="info.maritalStatus">
            <van-radio name="1" icon-size="0.6rem">未婚</van-radio>
            <van-radio name="2" icon-size="0.6rem">离异/无子女</van-radio>
            <van-radio name="3" icon-size="0.6rem">离异/有子女</van-radio>
            <van-radio name="4" icon-size="0.6rem">其他</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(19) }}.我是这样的人</van-col>
          </van-row>
          <van-cell title="请选择我是这样的人" is-link @click="goToTagSelector(1)">
            <template #label>
              <div style="display: flex; flex-wrap: wrap; margin-top: 0.2rem;"
                v-if="info.selectedPersonalityTags.length > 0">
                <van-tag v-for="(tag, index) in info.selectedPersonalityTags" :key="index" type="primary" size="small"
                  plain style="margin-right: 0.2rem; margin-bottom: 0.1rem;">{{ tag.tagName || tag }}</van-tag>
              </div>
            </template>
          </van-cell>
            <div style="font-size: 0.55rem; color: #999; margin: 0.2rem 0.8rem 0.4rem; line-height: 1.5;">鹊桥会AI将根据你选择的标签，从千余位用户中计算缘分指数。选得越准，遇见的人越对。</div>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(20) }}.个人兴趣爱好描述</van-col>
          </van-row>
          <van-checkbox-group v-model="info.descriptionOfPersonalInterests">
            <van-checkbox name="1" icon-size="0.6rem" shape="square">球类运动（篮球、兵乓球、羽毛球等）</van-checkbox>
            <van-checkbox name="2" icon-size="0.6rem" shape="square">体育运动（跑步、跳绳、健身等）</van-checkbox>
            <van-checkbox name="3" icon-size="0.6rem" shape="square">户外活动（旅游、登山）</van-checkbox>
            <van-checkbox name="4" icon-size="0.6rem" shape="square">文艺类（唱歌、跳舞、乐器）</van-checkbox>
            <van-checkbox name="5" icon-size="0.6rem" shape="square">娱乐类（逛街、看电影、看书）</van-checkbox>
            <van-checkbox name="6" icon-size="0.6rem" shape="square">冒险类（潜水，攀岩）</van-checkbox>
            <van-checkbox name="7" icon-size="0.6rem" shape="square">智力类（拼图、拆装）</van-checkbox>
            <van-checkbox name="8" icon-size="0.6rem" shape="square">游戏类（桌游、网游）</van-checkbox>
            <van-checkbox name="9" icon-size="0.6rem" shape="square">休闲类（园艺、写生、摄影）</van-checkbox>
            <van-checkbox name="10" icon-size="0.6rem" shape="square">美食类（火锅、烧烤等）</van-checkbox>
            <van-checkbox name="11" icon-size="0.6rem" shape="square">烹饪类（中餐、西餐、糕点）</van-checkbox>
            <van-checkbox name="12" icon-size="0.6rem" shape="square">其他</van-checkbox>
          </van-checkbox-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(21) }}.个人家庭情况描述</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem;">家庭成员人数及关系</span>
          <van-field v-model="info.personalFamilyDescription" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(22) }}.个人{{ COMPANYNAME == "ATL" ? "宁德" : ""
            }}住房情况</van-col>
          </van-row>
          <van-radio-group v-model="info.housingSituation">
            <van-radio name="1" icon-size="0.6rem">自己有住房</van-radio>
            <van-radio name="2" icon-size="0.6rem">已购房</van-radio>
            <van-radio name="3" icon-size="0.6rem">计划购房</van-radio>
            <van-radio name="4" icon-size="0.6rem">无计划</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(23) }}.个人信仰</van-col>
          </van-row>
          <van-radio-group v-model="info.personalBeliefs">
            <van-radio name="1" icon-size="0.6rem">基督教</van-radio>
            <van-radio name="2" icon-size="0.6rem">天主教</van-radio>
            <van-radio name="3" icon-size="0.6rem">佛教</van-radio>
            <van-radio name="4" icon-size="0.6rem">伊斯兰教</van-radio>
            <van-radio name="5" icon-size="0.6rem">无</van-radio>
            <van-radio name="6" icon-size="0.6rem">其他</van-radio>
          </van-radio-group>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(24) }}.期望结婚时间</van-col>
          </van-row>
          <van-field v-model="info.expectedMarriageDate" readonly placeholder="请选择期望结婚时间"
            @click="marriageTimeShow = true" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">{{ getBasicStepNumber(25) }}.联系电话</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem;">请填写您常用且绑定微信的手机号，便于红娘及时通知你匹配进度和活动提醒。</span>
          <van-field v-model="info.contactNumber" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem;margin-bottom: 0.2rem">{{ getBasicStepNumber(26) }}.个人照片上传</van-col>
          </van-row>
          <van-row class="upload" justify="space-between">
            <van-col span="24" class="upload-note">
              可上传多张，照片需五官清晰，明显识别本人，杜绝角度不正、墨镜遮挡或P图过度，支持jpg,png,gif,bmp,psd,tiff等图片格式。<br />
              <!-- <span style="color: #999">建议使用1:1尺寸照片</span> -->
            </van-col>
          </van-row>
          <van-uploader accept="image/*" :max-count="3" v-model="info.personalPhotos" class="van-upload"
            :before-read="onSelectPersonalPhoto" :before-delete="beforeDelete" />
          <van-row class="van-row van-star" justify="space-between" v-if="info.isAtl !== '1'">
            <van-col style="font-size: 0.6rem;margin-bottom: 0.2rem">{{ getBasicStepNumber(27) }}.身份证上传</van-col>
          </van-row>
          <van-row class="upload" justify="space-between" v-if="info.isAtl !== '1'">
            <van-col span="24" class="upload-note">外单位人员必须上传身份证，否则审核不予通过支持 jpg, png, gif,
              bmp, psd, tiff 等图片格式</van-col>
          </van-row>
          <van-uploader v-if="info.isAtl !== '1'" accept="image/*" :max-count="2" v-model="info.idPhotosOfOutsiders"
            class="van-upload" :before-read="idAfterRead" :before-delete="idBeforeDelete" />
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem;margin-top: 0.1rem">{{ getBasicStepNumber(28) }}.入会推荐人</van-col>
          </van-row>
          <span style="font-size: 0.6rem;margin-left: 0.8rem">外单位人员请填写推荐人身份＆姓名，有助于通过会员审核。</span>

          <van-radio-group v-model="info.referrerType" @change="confirmReferrerType">
            <van-radio name="1" icon-size="0.6rem">ATL鹊桥会红娘</van-radio>
            <van-radio name="2" icon-size="0.6rem">朋友/同事</van-radio>
            <van-radio name="3" icon-size="0.6rem">家人/亲属</van-radio>
            <van-radio name="4" icon-size="0.6rem">其他</van-radio>
          </van-radio-group>

          <van-field v-model="info.referrer" placeholder="请选择推荐红娘" readonly is-link @click="showRefe"
            v-if="info.referrerType === '1'" />
          <van-field v-model="info.referrer" placeholder="请输入推荐人姓名" v-else />

          <van-popup v-model="showPickerMatchmaker" round position="bottom" :style="{ height: '70%' }"
            class="matchmaker-search-popup">
            <div class="matchmaker-search-header">
              <span class="matchmaker-search-title">请选择推荐红娘</span>
              <van-icon name="cross" size="1.1rem" @click="showPickerMatchmaker = false" />
            </div>
            <van-search v-model="matchmakerSearchText" placeholder="输入红娘姓名搜索" shape="round" clearable />
            <div class="matchmaker-search-list">
              <div v-for="item in filteredMatchmakers" :key="item.id" class="matchmaker-search-item"
                :class="{ 'matchmaker-search-item--active': info.referrerId === item.id }"
                @click="selectMatchmaker(item)">
                <div class="matchmaker-search-item-info">
                  <span class="matchmaker-search-item-name">{{ item.name }}</span>
                  <span class="matchmaker-search-item-area">{{ getWorkAreaName(item.workArea) }}</span>
                </div>
                <van-icon v-if="info.referrerId === item.id" name="success" color="#FF2593" size="0.9rem" />
              </div>
              <div v-if="filteredMatchmakers.length === 0 && matchmakerSearchText" class="matchmaker-search-empty">
                未找到匹配的红娘
              </div>
            </div>
          </van-popup>
          <van-popup v-model="entryDateShow" round position="bottom">
            <van-datetime-picker v-model="entryDate" type="year-month" title="选择年月" :min-date="minDate"
              :max-date="maxDate" @confirm="confimDate" @cancel="entryDateShow = false" />
          </van-popup>
          <van-popup v-model="birthDateShow" round position="bottom">
            <van-datetime-picker v-model="birthday" type="year-month" title="选择年月" :min-date="birthMinDate"
              :max-date="maxDate" @confirm="confimBirthDate" @cancel="birthDateShow = false" />
          </van-popup>
          <van-popup v-model="marriageTimeShow" round position="bottom">
            <van-picker title="选择年份" :columns="marriageYearColumns" @confirm="confirmMarriageDate"
              @cancel="marriageTimeShow = false" :show-toolbar="true" />
          </van-popup>
          <van-popup v-model="areaCheck" position="bottom" :style="{ height: '50%' }">
            <van-area v-model="info.hometown" title="请选择所在地区" :area-list="areaData" :columns-num="2"
              @cancel="areaCheck = false" @confirm="onFinish" />
          </van-popup>
        </template>
        <template v-else>
          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">1.我想找这样的人</van-col>
          </van-row>
          <van-cell title="请选择我想找这样的人" is-link @click="goToTagSelector(2)">
            <template #label>
              <div style="display: flex; flex-wrap: wrap; margin-top: 0.2rem;"
                v-if="info.selectedSpouseTags.length > 0">
                <van-tag v-for="(tag, index) in info.selectedSpouseTags" :key="index" type="primary" size="small" plain
                  style="margin-right: 0.2rem; margin-bottom: 0.1rem;">{{ tag.tagName || tag }}</van-tag>
              </div>
            </template>
          </van-cell>
            <div style="font-size: 0.55rem; color: #999; margin: 0.2rem 0.8rem 0.4rem; line-height: 1.5;">鹊桥会AI将根据你选择的标签，从千余位用户中计算缘分指数。选得越准，遇见的人越对。</div>

          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">2.出生年份范围</van-col>
          </van-row>
          <van-field v-model="info.spouseBirthYearMin" readonly is-link placeholder="最小年份"
            @click="spouseBirthYearMinShow = true" />
          <van-field v-model="info.spouseBirthYearMax" readonly is-link placeholder="最大年份"
            @click="spouseBirthYearMaxShow = true" />

          <van-popup v-model="spouseBirthYearMinShow" round position="bottom">
            <van-picker title="选择最小出生年份" :columns="spouseBirthYearColumns" @cancel="spouseBirthYearMinShow = false"
              @confirm="confirmSpouseBirthYearMin" :show-toolbar="true" :default-index="25" />
          </van-popup>

          <van-popup v-model="spouseBirthYearMaxShow" round position="bottom">
            <van-picker title="选择最大出生年份" :columns="spouseBirthYearColumns" @cancel="spouseBirthYearMaxShow = false"
              @confirm="confirmSpouseBirthYearMax" :show-toolbar="true" :default-index="25" />
          </van-popup>


          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">3.身高范围（CM）</van-col>
          </van-row>
          <van-field v-model="info.spouseHeightMin" placeholder="最小身高（CM）" type="number"
            @change="spouseHeightMinChange" />
          <van-field v-model="info.spouseHeightMax" placeholder="最大身高（CM）" type="number"
            @change="spouseHeightMaxChange" />

          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">4.学历</van-col>
          </van-row>
          <van-radio-group v-model="info.spouseEducation">
          <van-radio name="0" icon-size="0.6rem">不限</van-radio>
            <van-radio name="1" icon-size="0.6rem">大专及以上</van-radio>
          <van-radio name="2" icon-size="0.6rem">本科及以上</van-radio>
          <van-radio name="3" icon-size="0.6rem">硕士及以上</van-radio>
          <van-radio name="4" icon-size="0.6rem">博士及以上</van-radio>
          </van-radio-group>

          <van-row class="van-row van-star" justify="space-between">
            <van-col style="font-size: 0.6rem">5.交友宣言</van-col>
          </van-row>
          <van-field v-model="info.datingDeclaration" type="textarea" rows="3" autosize
            placeholder="写一句你的交友宣言吧，让大家快速了解你~例如：真诚交友，希望找到一起看电影、聊日常的朋友" />
            <div style="font-size: 0.55rem; color: #969799; padding: 0.2rem 0.5rem; line-height: 1.4;">温馨提示：交友宣言将展示在您的名片页，好的宣言能让其他会员更快地了解您。</div>
        </template>
      </van-form>
    </div>
    <div class="registration">
      <van-checkbox-group v-model="registrationCheck">
        <van-checkbox name="1" shape="square"></van-checkbox>
        <span>
          我同意
          <a style="text-decoration:underline;" @click="showRegistrationTerms">{{ COMPANYNAME }}鹊桥会交友平台服务协议</a>
        </span>
      </van-checkbox-group>
      <van-popup v-model="registrationTermsVisible" style="width: 90%;height: 80%" closeable>
        <p class="registation-text">
          <span style="display: inline-block;width:100%;text-align:center;white-space: break-spaces;">{{ COMPANYNAME }}鹊桥会交友平台服务协议</span>
          <!-- <br /> -->
          <span style="display:none">
          <br />欢迎您注册{{ COMPANYNAME }}鹊桥会会员！ <br />{{
            COMPANYNAME
          }}鹊桥会是一个真诚且严肃的婚恋交友平台（以下简称本平台），隶属于{{
            ChineseCOMPANYNAME
          }}工会委员会，是官方指定的唯一组织。请您（以下简称"用户"或"会员"）在使用本平台之前认真阅读以下全部内容。无论您是否选择注册成为本平台的会员，使用本平台就表示您已完全接受本协议的所有条款。如果您不同意本协议，请不要使用本平台。
          <!-- 协议内容省略 -->
          </span>
          欢迎您注册ATL鹊桥会会员！
          ATL鹊桥会是一个真诚且严肃的婚恋交友平台（以下简称本平台），隶属于宁德新能源科技有限公司工会委员会，是官方指定的唯一组织。请您（以下简称“用户”或“会员”）在使用本平台之前认真阅读以下全部内容。无论您是否选择注册成为本平台的会员，使用本平台就表示您已完全接受本协议的所有条款。如果您不同意本协议，请不要使用本平台。一旦您通过进入页面并勾选“我已阅读并同意ATL鹊桥会交友平台服务协议”注册成为本平台会员并使用本平台提供的任何服务，或者您未注册成为本平台会员，但通过阅读、浏览、复制等其他任何方式使用本平台提供的任何信息以及以其他方式使用本平台提供的各类服务，就表示您与本平台达成协议，自愿接受本协议的所有内容，并认可我们已采取合理的方式提醒您注意该条款。此后，您不得以未阅读本服务条款内容等理由，主张本条款无效或要求撤销本条款。
          本协议自您开始使用本平台或注册成为本平台会员之日起生效，您应遵守以下鹊桥会交友平台的各项条款：
          一、会员注册规则 
          1、会员确认：在注册成为本平台的会员或使用本平台时，已满足下列全部条件： 
          1）在注册之日必须为年满18周岁的完全民事行为能力人； 
          2）在注册之日以及此后使用本平台服务期间必须是单身状态，包括未婚、离异
          或是丧偶； 
          3）在注册之日以及此后使用本平台服务期间必须以恋爱或者婚姻为目的。
          4）在使用鹊桥会交友服务期间，如果您的状态发生变更，已经不符合会员注册资格，请联系管理员注销您的会员资格，否则由此产生的责任由您自行承担。
          2、为更好地享有本平台提供的服务，您同意并保证： 
          1）您向本平台的本人资料是真实、合法、准确、完整及最新的，不得通过任何手段恶意注册鹊桥会账号（包括但不限于使用无效手机号、无效未验证邮箱、使用他人身份等恶意注册），并且愿意应我们的要求提供相应证件（包括但不限于：身份证、学历证明、婚姻状况证明、户口本等有效证件）予我们进行验证； 
          2）上述信息发生变更，您应及时进行更新； 
          3）征友过程中，务必保持本平台账号的唯一性。 
          若会员提供任何错误、不实或不完整的资料，或本平台有理由怀疑资料为错误、不实或不完整及违反会员注册条款的，或本平台有理由怀疑其会员资料有悖于“严肃真诚的婚恋交友”主题的，本平台有权修改或删除会员资料，暂时或永久关闭该会员的帐号，或暂停或终止提供本平台的服务。
          3、会员必须确保自己是本平台的合法使用权人，并应妥善保管您的账号、密码的安全，并对其该账号密码下所从事的所有行为承担责任。会员账号具有唯一性和不可转让性，您不得将会员账号以任何方式提供给他人使用，包括但不限于转让、出租、出借、售卖或分享等方式。否则，因此产生一切纠纷、损失和法律责任均由会员自行承担，且本平台有权根据实际情况暂时关闭或永久关闭此账号。因会员保管不善导致盗号或密码失窃，进而导致资料、信息泄漏的，由会员自行承担不利后果。当会员的账号或密码遭到未经授权的使用时或者发生其它任何安全问题时，会员应当立即通知本平台，否则未经授权的使用行为均视为会员本人的行为。
          二、服务内容与说明
          1、在满足上述资格的情况下，您可以注册成为本平台的会员。作为会员，您有权使用本平台提供的相关功能和服务。
          2、本平台的服务分为红娘服务和联谊活动。“红娘服务”是指红娘根据会员的择偶要求进行一对一介绍服务。“联谊活动”是指由鹊桥会平台每个月定期组织的联谊活动；
          3、本平台的所有服务一律不收取任何费用；
          4、会员在使用本平台时，应遵守宪法法律，包括但不限于《中华人民共和国民法典》、《中华人民共和国著作权法》、《全国人民代表大会常务委员会关于维护互联网安全的决定》、《中华人民共和国保守国家秘密法》、《中华人民共和国电信条例》、《中华人民共和国计算机信息系统安全保护条例》、《中华人民共和国计算机信息网络国际联网管理暂行规定》及其实施办法、《计算机信息系统国际联网保密管理规定》、《互联网信息服务管理办法》、《计算机信息网络国际联网安全保护管理办法》、《互联网电子公告服务管理规定》、《中华人民共和国网络安全法》等与互联网信息服务有关的法律法规；同时应遵守公共秩序，尊重社会公德。
          5、在任何情况下，本平台一旦有理由认为会员使用世纪本平台中的任何行为违反或可能违反上述法律和法规的任何规定，本平台可在任何时候不经事先通知终止向该会员提供服务。会员知悉并同意：在使用本平台服务时，禁止从事下列行为:
          1)制作、上传、复制、发布、传播或以其它方式传送含有下列信息的内容（包括但不限于照片、文字、图片、语音、视频、图文、信息或其他资料）：
          ①反对宪法所确定的基本原则的；
          ②危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
          ③散布谣言，扰乱社会秩序，破坏社会稳定的；
          ④侮辱或者诽谤他人，侵害他人合法权利的；
          ⑤含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它有悖道德、令人反感的内容；
          ⑥含有中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的其它内容的。
          2)冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或机构有关。 
          3)将侵犯任何人的肖像权、名誉权、隐私权、专利权、商标权、著作权、商业秘密或其它专属权利的内容上载、张贴、发送电子邮件或以其它方式传送的。 
          4)伪造标题或以其他方式操控识别资料，使人误认为该内容为平台所传送；
          5)跟踪或以其它方式骚扰其他会员，非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的行为；
          6）将病毒或其它计算机代码、档案和程序，加以上载、张贴、发送电子邮件或以其它方式传送的。 
          7) 未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。 
          8）干扰或破坏本平台服务或与本平台服务相连的服务器和网络，或违反本协议干扰本平台服务。
          9）对平台的服务或服务的任何部分及会员资料，进行复制、拷贝、出售、转售或用于任何其他商业目的。
          10）故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范或违背严肃婚恋交友目的行为。
          6、会员在本平台制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的，应保证其上传内容不违反法律法规及其规范性文件，亦不侵犯任何第三方的合法权益，否则导致的一切不利后果均由会员自行承担；造成本平台损失的，还应向本平台赔偿责任包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。同时：
          1）为了维护法律法规及相关规范性文件、保护他人的合法权益、维护本平台的信誉及安全，本平台有权直接修改、删除、下线、屏蔽会员利用本平台服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容，而无需事先通知会员；
          2）本平台有权视情节严重程度对该会员做出警告、加黑、关闭会员账号的处罚。
          3）本平台的后台记录有可能作为会员违反法律法规、违约、侵权的证据。
          7、会员应当保证，不会利用本平台服务或其衍生服务侵犯本平台以及他人的合法权益，禁止通过网络漏洞、恶意软件或其他手段破坏本平台的正常经营，窃取、盗用他人的账号及账号下财产等；禁止侵犯他人合法权益或违反本使用规则的其他内容。否则，本平台有权根据情节严重而对该会员及会员账号采取措施：包括但不限于发出警告、加黑、关闭账号等处罚。如因此造成本平台损失的，会员应负责全部赔偿。构成犯罪的，本平台有权移交司法部门处理。
          8、会员在投诉其他会员有违法违规行为或违反本协议情形时，投诉者应承担不实投诉所产生的全部法律责任。如侵犯他人的合法权益，投诉人应独立承担全部法律责任。如给本平台造成损失的，投诉人应承担相应的赔偿责任。 
          三、隐私
          1、您在使用本平台和/或本平台所提供之服务时也应受我们的“信息保护政策”的约束。为了达成向您提供及时、优质服务之目的，在您注册时或访问本平台网页，或使用本平台产品或服务，或参加任何形式的会员活动时，我们会收集并使用您的个人信息。这些个人信息包括但不限于：您的姓名、昵称、出生年月、性别、身高、体重、籍贯、学历、毕业学校，个人兴趣爱好，家庭情况、行业、收入、照片、手机号码及电子邮件地址等联系方式和个人信息以及网站自动接收并记录会员的浏览器和服务器日志上的信息(含会员登录所在地的IP地址、在线、无线信息、信件资料等)。本平台收集上述信息将用于：提供网站服务、改进网页内容、通知会员最新消息、活动信息、或根据法律法规要求的用途。
          2、您提供的上述个人信息将存储在我们的计算机上。一经缔结本协议则意味着您同意我们在您会员身份终止前，无需您事先同意即可无偿使用该等信息为您提供婚介服务或您定制其他相关服务，包括但不限于创建兴趣、偏好和浏览模式档案或开展其它活动。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。
          3、为了保证向您提供及时、优质的服务，本平台会向您提供的电话、手机、电子邮箱拨打电话或发送短信及邮件（内容包括但不限于服务流程确认，其他会员希望与您联系、约见，活动信息和咨询、新服务推介等、提示再次登录本平台等）。您注册为我们的会员即表示您已经明确同意接听上述电话或收到短信、邮件；如您不想接听上述电话或收到短信、邮件，请您拨打客服电话或登录本平台注销您的注册账号。如您未注销您的账户，则视为您同意接听或接受本平台给您的电话、短信及邮件。
          4、您在缔结本协议时已理解并同意，您在本平台上公开发布的个人基础信息（不包含姓名），任何登陆到本平台的第三人均可查看。尊重用户个人隐私是本平台的一项基本政策。所以，在未经您的授权时本平台不会公开、编辑或透露您的未在本平台上公开发布的个人信息及保存在本平台各项服务中的非公开内容。但是为了保证向您提供及时、优质的服务，我们在诚信的基础上认为透露这些信息某些情况是必要的，我们会将您的个人信息向下列第三人提供： (a)、本平台的所有认证红娘；( b)、您已明确同意让第三方共享资料；( c)、为保护本平台、会员及社会公众的财产权利或人身权利；( d)、根据法律法规的规定，向司法机关提供； (e)执行软件升级服务；(f)网络同步服务；(g)提高用户的使用安全性并提供客户支持；(h)被搜索引擎在搜索结果中显示； (i)受到黑客攻击导致会员信息泄漏的； 
          5、在前述情况下我们将您的个人信息提供给第三方不需要获得您事先同意。如因此给您造成任何损害您同意免除我们的相应法律责任。
          四、免责声明
          1、于缔结本协议时，您已同意就下列事由免除我们的法律责任： 
          1）我们会依据本协议为您提供服务，但您已理解并同意我们不保证所提供的服务一定能满足您的要求和期望，或将最终帮助您找到您的伴侣。
          2）我们并不保证我们提供的各类服务的稳定性、及时性，对于由此给您造成的任何不便或损害，您于缔结协议时已表示理解并同意免除我们与此相应的法律责任。如在本平台运营过程中出现我们误将您的帐户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。
          3）您承认对于您利用本平台提供的服务或信息而从事的各类行为，包括在本平台发布各类信息，利用本平台提供之信息联系红娘或其他会员等，均为您个人行为且您个人对该类行为承担完全责任。 
          4）于缔结本协议时，您已清楚认识到，我们并不确认通过我们、我们的合作伙伴、会员或他人所提供的服务而展示、上传或散布于本平台的任何建议、意见、声明或其他文字或图像信息的准确性和可靠性。您同意由您自己对该类意见、会员档案、建议、声明或其他文字或图像信息的准确性进行独立判断并独立承担由此带来的风险。 我们对会员的行为，无论是在线还是离线行为，均不承担法律责任。在使用本平台及本平台提供之服务时，我们建议您依据常识并采取小心谨慎的态度。 
          5）对于会员通过本平台传送的包括照片、资料、证件等信息，本平台已采用相关措施并已尽合理努力进行审核，但无法完全控制经由本平台服务传送的所有信息，不保证内容的正确性、完整性或品质。相关责任由上传上述内容的会员负责。因此您在使用本平台时，可能会接触到令人不快、不适当或令人厌恶的内容。您同意在任何情况下，我们均不为会员经由本平台以张贴、发送电子邮件或其它方式传送的任何内容负责，但本平台有权依法停止传输任何上述内容并采取相应行动，包括但不限于暂停会员使用本平台服务的全部或部分，保存有关记录，并依据国家法律法规、相关政策在必要时向有关机关报告并配合有关机关的行动。
          6）您在使用本平台提供的服务（无论线上或是线下）或者是在与其本平台其他会员认识、交往的过程中，您应以自己的独立判断来确定该会员上传的资料的真实性、准确性，并独立承担可能产生的不利后果和责任，本平台不承担任何法律责任。
          7）对于会员自发组织的任何活动，或自发成立的组织的任何行为，本平台概不负责。
          8）对于会员的投诉，本平台将认真核实，但不能保证最终公布的投诉处理结果的完全公正，您同意对于投诉内容和投诉处理结果，如侵犯您的隐私权、名誉权等合法权利，免除本平台的相应法律责任。
          本平台保留根据业务发展情况修改上述免责事由的权利。
          五、会员争议的解决
            您理解并同意本平台仅仅是为您和其他会员的交往提供平台，但对您与其他本平台会员的来往，无论是在网上或在现实生活中，您都须对您的行为承担全部责任。如您与其他会员产生争议，则您理解并同意本平台并没有义务监控或处理您与其他会员之间的争议。
          风险提示：会员应增强自我保护和防范意识。
          六、不可抗力
            您同意并认可，对于因超出我们合理控制范围的任何事件或情况，包括但不限于战争、入侵、恐怖袭击、自然灾害或其他不可抗力，以及任何技术故障的发生、电气短路、第三方侵入本平台等情况所给您造成的任何损失或损害，我们无需承担任何赔偿责任，并不被视为违反本协议。
          七、法律适用、争议和管辖
          1、您知悉并同意：本协议的生效、履行、解释及争议的解决均适用中华人民共和国的现行法律；如会员与本平台就本协议内容或其执行发生任何争议，首先应友好协商解决；协商不成时，会员同意将纠纷提交至福建省宁德市蕉城区的人民法院管辖。
          2、会员之间争议的解决。您理解并同意本平台仅仅是为您和其他会员的婚恋交友提供信息服务的平台，但对于您与其他本平台的来往，无论是在网上或在现实生活中，您都须对您的行为承担全部责任。如您与其他会员产生争议，则您理解并同意本平台并没有法定义务监控或处理您与其他会员之间的争议。
          3、本协议因与中华人民共和国现行法律相抵触而导致部分条款无效的，不影响其他条款的效力。
          4、本协议的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
          风险提醒：在任何情况下，会员不应轻信借款、投资、理财、赌彩或其他涉及财产的网络信息。
        </p>
      </van-popup>
    </div>
    <van-button class="submit-button" @click="handleSubmitOrNext">{{ activeTab === 'basic' ? '下一步' : '提交'
    }}</van-button>
    <van-popup v-model="customerServicePopupVisible" class="customer-service-popup" :close-on-click-overlay="false"
      :safe-area-inset-bottom="true">
      <div class="customer-service-popup__content">
        <div class="customer-service-popup__title">入会申请已提交</div>
        <div class="customer-service-popup__desc">
          您的编号是：{{ serialNumber }}
          <!-- 等待审核通过(1-2个工作日） -->
        </div>
        <img class="customer-service-popup__qr" :src="clientWechatQr" alt="客服微信二维码"
          style="max-width: 200px; width: 100%; object-fit: contain;" />
        <div class="customer-service-popup__remark">长按保存图片
        </div>
        <div class="customer-service-popup__wechat">
          立即添加客服微信：18859389611
        </div>
        <div class="customer-service-popup__remark">
          添加好友请备注：编号+姓名，便于后续联系。
          <!-- 备注「{{ customerServiceRemark }}」，便于后续服务。 -->
        </div>
        <van-button type="primary" block round class="customer-service-popup__button"
          @click="handleCustomerServicePopupConfirm">
          我知道了
        </van-button>
      </div>
    </van-popup>

    <avatar-cropper :visible.sync="cropperVisible" :img-src="rawImgSrc" @confirm="onCropConfirm" @cancel="onCropCancel"
      :fixedNumber="fixedNumber" />
  </div>
</template>

<script>
import { getOaInfo, getToken } from "@/utils/auth";
import { areaList } from "@vant/area-data";
import { Toast } from "vant";
import {
  submitPersonInfo,
  upLoadImages,
  savePersonalityTags,
  saveSpouseRequirementTags,
  getEmployeeInfoByEmployeeNo
} from "../api/user";
import { getAllMatchmakerInfo } from "../api/matchmakerInfo";
import clientWechatQr from "../assets/client_wechat.png";
import AvatarCropper from "../components/AvatarCropper.vue";

export default {
  components: { AvatarCropper },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      fixedNumber: [1, 1], // 截图框比例
      ChineseCOMPANYNAME: process.env.ChineseCOMPANYNAME,
      COMPANYNAME: process.env.COMPANYNAME,
      TEL: process.env.TEL,
      registrationCheck: [],
      registrationTermsVisible: false,
      maxDate: new Date(),
      minDate: new Date(2010, 0, 1),
      birthMinDate: new Date(1975, 0, 1),
      marriageYearColumns: Array.from(
        { length: 21 },
        (_, index) => `${new Date().getFullYear() + index}`
      ),
      entryDateShow: false,
      birthDateShow: false,
      marriageTimeShow: false,
      spouseBirthYearMinShow: false,
      spouseBirthYearMaxShow: false,
      areaData: areaList,
      areaCheck: false,
      // 入会推荐人搜索选择
      showPickerMatchmaker: false,
      allMatchmakers: [],
      matchmakerSearchText: "",
      entryDate: new Date(),
      birthday: new Date(1995, 0, 1),

      disabled: false,
      activeTab: "basic",
      customerServicePopupVisible: false,
      customerServiceRemark: "会员编号+姓名",
      serialNumber: "会员编号",
      clientWechatQr,
      spouseBirthYearColumns: Array.from(
        { length: 2020 - 1970 + 1 },
        (_, index) => `${2020 - index}`
      ),
      info: {
        sex: "",
        isAtl: "",
        companyName: "",
        positionTitle: "",
        avatarLink: "",
        personalPhotos: [],
        department: "",
        employeeNo: "",
        name: "",
        nickName: "",
        birthday: "",
        hometown: "",
        weight: "",
        height: "",
        nation: "",
        education: "",
        graduateSchool: "",
        maritalStatus: "",
        personalCharacterDescription: "",
        personalFamilyDescription: "",
        entryDate: "",
        expectedMarriageDate: "",
        descriptionOfPersonalInterests: [],
        descriptionOfSpouseSelectionRequirements: "",
        contactNumber: "",
        referrer: "",
        referrerId: "",
        referrerType: "1",
        personalBeliefs: "",
        housingSituation: "",
        idPhotosOfOutsiders: [],
        matchmakerInfoId: "",
        selectedPersonalityTags: [],
        selectedSpouseTags: [],
        datingDeclaration: "",
        spouseBirthYearMin: "",
        spouseBirthYearMax: "",
        spouseSex: "",
        spouseHeightMin: "",
        spouseHeightMax: "",
        spouseEducation: "",
        weChatOpenId: ""
      },
      cropperVisible: false,
      rawImgSrc: '',
      cropTarget: ''
    };
  },
  methods: {
    // 显示红娘搜索选择弹窗
    showRefe() {
      this.matchmakerSearchText = "";
      this.showPickerMatchmaker = true;
      if (this.allMatchmakers.length === 0) {
        this.loadAllMatchmakers();
      }
    },
    // 加载所有红娘信息
    loadAllMatchmakers() {
      getAllMatchmakerInfo().then(res => {
        if (res.code === 20000 && res.data) {
          this.allMatchmakers = res.data;
        }
      }).catch(() => { });
    },
    // 选择推荐人
    selectMatchmaker(item) {
      this.info.referrer = item.name;
      this.info.referrerId = item.id;
      this.showPickerMatchmaker = false;
    },
    // 获取工作区域名称
    getWorkAreaName(workArea) {
      const areaMap = { 1: "W区", 2: "E区", 3: "M区", 4: "R区" };
      return areaMap[workArea] || "";
    },
    openCropper(file, target) {
      if (target === 'personalPhoto' && this.info.personalPhotos.length >= 3) {
        Toast({ message: '最多上传3张照片' });
        return false;
      }
      if (target === 'personalPhoto') {
        this.fixedNumber = [100, 69];
      } else {
        this.fixedNumber = [1, 1];
      }
      this.cropTarget = target;
      const reader = new FileReader();
      reader.onload = e => {
        this.rawImgSrc = e.target.result;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);
      return false;
    },
    resetCropperState() {
      this.cropperVisible = false;
      this.rawImgSrc = '';
      this.cropTarget = '';
    },
    // 选择头像，打开裁剪弹窗
    onSelectAvatar(file) {
      return this.openCropper(file, 'avatar');
    },
    onSelectPersonalPhoto(file) {
      return this.openCropper(file, 'personalPhoto');
    },
    async uploadCroppedImage(blob, fileName) {
      const formData = new FormData();
      formData.append('formFile', blob, fileName);
      return upLoadImages(formData);
    },
    onCropCancel() {
      this.resetCropperState();
    },
    confirmReferrerType(value) {
      this.info.referrer = '';
      this.info.referrerId = '';
      this.info.referrerType = value;
    },
    // 裁剪确认后上传到服务器
    async onCropConfirm(blob) {
      const cropTarget = this.cropTarget;
      const localUrl = URL.createObjectURL(blob);
      if (cropTarget === 'avatar') {
        this.info.avatarLink = localUrl;
      }
      try {
        const res = await this.uploadCroppedImage(blob, cropTarget === 'avatar' ? 'avatar.jpg' : 'personal-photo.jpg');
        if (res && res.code === 20000) {
          if (cropTarget === 'avatar') {
            this.info.avatarLink = res.data;
            Toast({ message: '头像上传成功' });
          } else if (cropTarget === 'personalPhoto') {
            this.info.personalPhotos = [
              ...this.info.personalPhotos,
              { url: res.data }
            ];
            Toast({ message: '照片上传成功' });
          }
        } else {
          if (cropTarget === 'avatar') {
            this.info.avatarLink = '';
            Toast({ message: '头像上传失败' });
          } else {
            Toast({ message: '照片上传失败' });
          }
        }
      } catch (e) {
        if (cropTarget === 'avatar') {
          this.info.avatarLink = '';
          Toast({ message: '头像上传失败' });
        } else {
          Toast({ message: '照片上传失败' });
        }
      } finally {
        URL.revokeObjectURL(localUrl);
        this.resetCropperState();
      }
    },
    onClickLeft() {
      if (getToken()) {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    goToTagSelector(tagType) {
      this.$router.push({
        path: "/tagSelector",
        query: { tagType: tagType, memberId: "" }
      });
    },
    getCustomerServiceRemark(baseInfo) {
      const serialNumber = baseInfo && baseInfo.serialNumber ? baseInfo.serialNumber : "会员编号";
      const name = (baseInfo && baseInfo.name) || this.info.name || "姓名";
      return `${serialNumber}+${name}`;
    },
    handleCustomerServicePopupConfirm() {
      this.customerServicePopupVisible = false;
      this.$router.push({ path: "/homePage" });
    },
    loadSelectedTags() {
      const selectedTags = localStorage.getItem("selectedTags");
      if (selectedTags) {
        try {
          const tags = JSON.parse(selectedTags);
          if (tags.personalityTags && tags.personalityTags.length > 0) {
            this.info.selectedPersonalityTags = tags.personalityTags;
          }
          if (
            tags.spouseRequirementTags &&
            tags.spouseRequirementTags.length > 0
          ) {
            this.info.selectedSpouseTags = tags.spouseRequirementTags;
          }
        } catch (e) {
          console.error("解析标签缓存失败", e);
        }
      }
    },
    saveFormData() {
      const formData = JSON.stringify({
        info: this.info,
        activeTab: this.activeTab
      });
      sessionStorage.setItem("joinFormData", formData);
    },
    loadFormData() {
      const formData = sessionStorage.getItem("joinFormData");
      if (formData) {
        try {
          const parsed = JSON.parse(formData);
          const cachedInfo = parsed.info || parsed;
          Object.keys(cachedInfo).forEach(key => {
            if (!Object.prototype.hasOwnProperty.call(this.info, key)) {
              return;
            }
            if (key === "personalPhotos" || key === "idPhotosOfOutsiders") {
              if (!this.info[key] || this.info[key].length === 0) {
                this.info[key] = cachedInfo[key];
              }
            } else {
              this.info[key] = cachedInfo[key];
            }
          });
          if (parsed.activeTab) {
            this.activeTab = parsed.activeTab;
          }
        } catch (e) {
          console.error("解析表单缓存失败", e);
        }
      }
      this.loadSelectedTags();
    },
    handleShowPop(value, disabled) {
      if (!disabled) {
        this[value] = true;
      }
    },
    beforeDelete(file, detail) {
      this.info.personalPhotos.splice(detail.index, 1);
    },
    idAfterRead(file) {
      const formData = new FormData();
      formData.append("formFile", file);
      upLoadImages(formData).then(res => {
        if (res) {
          this.info.idPhotosOfOutsiders = [
            ...this.info.idPhotosOfOutsiders,
            { url: res.data }
          ];
        } else {
          Toast({ message: "上传失败" });
        }
      });
    },
    idBeforeDelete(file, detail) {
      this.info.idPhotosOfOutsiders.splice(detail.index, 1);
    },
    confimDate() {
      this.entryDateShow = false;
      let month = new Date(this.entryDate).getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      this.info.entryDate =
        new Date(this.entryDate).getFullYear() + "-" + month;
    },
    confimBirthDate() {
      this.birthDateShow = false;
      let month = new Date(this.birthday).getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      this.info.birthday = new Date(this.birthday).getFullYear() + "-" + month;
    },
    confirmMarriageDate(value) {
      this.marriageTimeShow = false;
      this.info.expectedMarriageDate = `${value}`//-01-01`;
    },
    confirmSpouseBirthYearMin(value) {
      if (this.info.spouseBirthYearMax && this.info.spouseBirthYearMax < value) {
        Toast({ message: "不能大于最大年份" });
        return;
      }
      this.spouseBirthYearMinShow = false;
      this.info.spouseBirthYearMin = value;
    },
    confirmSpouseBirthYearMax(value) {
      if (this.info.spouseBirthYearMin && this.info.spouseBirthYearMin > value) {
        Toast({ message: "不能小于最小年份" });
        return;
      }
      this.spouseBirthYearMaxShow = false;
      this.info.spouseBirthYearMax = value;
    },
    spouseHeightMinChange() {
      if (this.info.spouseHeightMax && this.info.spouseHeightMax < this.info.spouseHeightMin) {
        Toast({ message: "不能大于最大身高" });
        this.info.spouseHeightMin = null;
        return;
      }
    },
    spouseHeightMaxChange() {
      if (this.info.spouseHeightMin && this.info.spouseHeightMin > this.info.spouseHeightMax) {
        Toast({ message: "不能小于最小身高" });
        this.info.spouseHeightMax = null;
        return;
      }
    },
    getEducationText(value) {
      const educationMap = {
        "1": "大专",
        "2": "本科",
        "3": "硕士",
        "4": "博士",
        "5": "高中及以下"
      };
      return educationMap[value] || "";
    },
    getSpouseEducationText(value) {
      const map = {
        "0": "不限",
        "1": "大专及以上",
        "2": "本科及以上",
        "3": "硕士及以上",
        "4": "博士及以上"
      };
      return map[value] || "";
    },
    buildSpouseTagText() {
      return this.info.selectedSpouseTags
        .map(tag => tag.tagName || tag.customTagName || tag)
        .filter(Boolean)
        .join("、");
    },
    buildSpouseRequirementText() {
      const sections = [];
      const spouseTagText = this.buildSpouseTagText();
      if (spouseTagText) {
        sections.push(`我想找这样的人：${spouseTagText}`);
      }
      if (this.info.spouseBirthYearMin && this.info.spouseBirthYearMax) {
        sections.push(`出生年份：${this.info.spouseBirthYearMin}年-${this.info.spouseBirthYearMax}年`);
      }
      if (this.info.spouseSex) {
        sections.push(`性别：${this.info.spouseSex === "1" ? "男" : "女"}`);
      }
      if (this.info.spouseHeightMin && this.info.spouseHeightMax) {
        sections.push(`身高：${this.info.spouseHeightMin}CM-${this.info.spouseHeightMax}CM`);
      }
      if (this.info.spouseEducation) {
        sections.push(`学历：${this.getSpouseEducationText(this.info.spouseEducation)}`);
      }
      return sections.join("；");
    },
    validateSpouseRequirements() {
      if (this.info.selectedSpouseTags.length === 0) {
        this.activeTab = "spouse";
        Toast.fail({ message: "请选择我想找这样的人" });
        return false;
      }
      const spouseFields = [
        { key: "spouseBirthYearMin", label: "最小出生年份" },
        { key: "spouseBirthYearMax", label: "最大出生年份" },
        { key: "spouseHeightMin", label: "最小身高" },
        { key: "spouseHeightMax", label: "最大身高" },
        { key: "spouseEducation", label: "学历" }
      ];
      for (let i = 0; i < spouseFields.length; i++) {
        const { key, label } = spouseFields[i];
        if (!this.info[key]) {
          this.activeTab = "spouse";
          Toast.fail({ message: `请完善择偶要求：${label}` });
          return false;
        }
      }
      const spouseBirthYearMin = Number(this.info.spouseBirthYearMin);
      const spouseBirthYearMax = Number(this.info.spouseBirthYearMax);
      if (spouseBirthYearMin < 1970 || spouseBirthYearMin > 2020 ||
        spouseBirthYearMax < 1970 || spouseBirthYearMax > 2020) {
        this.activeTab = "spouse";
        Toast.fail({ message: "择偶要求中的出生年份范围需在1970-2020之间" });
        return false;
      }
      if (spouseBirthYearMin > spouseBirthYearMax) {
        this.activeTab = "spouse";
        Toast.fail({ message: "最小出生年份不能大于最大出生年份" });
        return false;
      }
      const spouseHeightMin = Number(this.info.spouseHeightMin);
      const spouseHeightMax = Number(this.info.spouseHeightMax);
      if (spouseHeightMin < 100 || spouseHeightMax < 100 ||
        spouseHeightMin > 250 || spouseHeightMax > 250) {
        this.activeTab = "spouse";
        Toast.fail({ message: "择偶要求中的身高范围需在100-250CM之间" });
        return false;
      }
      if (spouseHeightMin > spouseHeightMax) {
        this.activeTab = "spouse";
        Toast.fail({ message: "最小身高不能大于最大身高" });
        return false;
      }
      return true;
    },
    validateBasicInfo() {
      if (this.registrationCheck && this.registrationCheck.length === 0) {
        Toast.fail({
          message: `请先阅读并勾选 ${this.COMPANYNAME}鹊桥会交友平台服务协议`
        });
        return false;
      }
      if (this.info.selectedPersonalityTags.length === 0) {
        Toast.fail({ message: "请选择我是这样的人" });
        return false;
      }
      if (this.info.isAtl === "2") {
        if (this.info.sex && this.info.sex === "1") {
          Toast.fail({ message: "外单位会员必须为女性" });
          return false;
        }
        if (
          this.info.idPhotosOfOutsiders &&
          this.info.idPhotosOfOutsiders.length !== 2
        ) {
          Toast({ message: "身份证需要上传正反面2张" });
          return false;
        }
      }
      if (this.info.contactNumber) {
        let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg_tel.test(this.info.contactNumber)) {
          Toast.fail({
            message: "请输入正确的手机号",
            className: "phoneErrMessage"
          });
          return false;
        }
      }
      if (!this.info.avatarLink) {
        Toast.fail({ message: "请上传头像" });
        return false;
      }
      if (!this.info.referrer) {
        Toast.fail({ message: "请填写入会推荐人" });
        return false;
      }
      return true;
    },
    handleSubmitOrNext() {
      if (this.activeTab === 'basic') {
        if (!this.validateBasicInfo()) {
          return;
        }
        this.activeTab = 'spouse';
        // 滚动到页面顶部
        window.scrollTo(0, 0);
        return;
      }
      this.submitPersonInfo();
    },
    submitPersonInfo() {
      if (this.registrationCheck && this.registrationCheck.length === 0) {
        Toast.fail({
          message: `请先阅读并勾选 ${this.COMPANYNAME}鹊桥会交友平台服务协议`
        });
        return;
      }
      if (this.info.selectedPersonalityTags.length === 0) {
        Toast.fail({ message: "请选择我是这样的人" });
        return;
      }
      if (this.info.isAtl === "2") {
        if (this.info.sex && this.info.sex === "1") {
          Toast.fail({ message: "外单位会员必须为女性" });
          return;
        }
        if (
          this.info.idPhotosOfOutsiders &&
          this.info.idPhotosOfOutsiders.length !== 2
        ) {
          Toast({ message: "身份证需要上传正反面2张" });
          return;
        }
      }
      if (this.info.contactNumber) {
        let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg_tel.test(this.info.contactNumber)) {
          Toast.fail({
            message: "请输入正确的手机号",
            className: "phoneErrMessage"
          });
          return;
        }
      }
      if (!this.validateSpouseRequirements()) {
        return;
      }
      if (this.info.isAtl === "2") {
        delete this.info.employeeNo;
      }
      if (!this.info.avatarLink) {
        Toast.fail({ message: "请上传头像" });
        return;
      }
      const skipFields = [
        "matchmakerInfoId",
        "idPhotosOfOutsiders",
        "referrerId",
        "matchmakerName",
        "employeeNo",
        "nickName",
        "selectedPersonalityTags",
        "selectedSpouseTags",
        "personalCharacterDescription",
        "descriptionOfSpouseSelectionRequirements",
        "weChatOpenId"
      ];
      const fieldLabelMap = {
        isAtl: "单位类型",
        companyName: "公司名称",
        positionTitle: "岗位名称",
        avatarLink: "头像",
        personalPhotos: "个人照片",
        department: "所在部门",
        name: "姓名",
        birthday: "出生日期",
        hometown: "籍贯",
        weight: "体重",
        height: "身高",
        nation: "民族",
        education: "学历",
        graduateSchool: "毕业学校名称",
        maritalStatus: "婚姻状态",
        personalFamilyDescription: "个人家庭情况描述",
        entryDate: "入职日期",
        expectedMarriageDate: "期望结婚时间",
        descriptionOfPersonalInterests: "个人兴趣爱好描述",
        contactNumber: "联系电话",
        personalBeliefs: "个人信仰",
        housingSituation: "个人住房情况",
        datingDeclaration: "交友宣言",
        spouseBirthYearMin: "择偶最小出生年份",
        spouseBirthYearMax: "择偶最大出生年份",
        spouseHeightMin: "择偶最小身高",
        spouseHeightMax: "择偶最大身高",
        spouseEducation: "择偶学历",
        sex: "性别"
      };
      const spouseFields = [
        "spouseBirthYearMin", "spouseBirthYearMax",
        "spouseHeightMin", "spouseHeightMax",
        "spouseEducation", "datingDeclaration"
      ];
      for (var item in this.info) {
        if (
          (!this.info[item] || this.info[item].length === 0) &&
          !skipFields.includes(item)
        ) {
          const fieldLabel = fieldLabelMap[item] || "该项";
          Toast({ message: `请完善${fieldLabel}` });
          if (spouseFields.includes(item)) {
            this.activeTab = "spouse";
          } else {
            this.activeTab = "basic";
          }
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
          return;
        }
      }
      if (this.info.isAtl === "2") {
        this.info.employeeNo = "";
      }
      const submitData = { ...this.info };
      submitData.descriptionOfSpouseSelectionRequirements = this.buildSpouseRequirementText();
      submitData.spouseBirthYearMin = Number(this.info.spouseBirthYearMin);
      submitData.spouseBirthYearMax = Number(this.info.spouseBirthYearMax);
      submitData.spouseSex = Number(this.info.spouseSex);
      submitData.spouseHeightMin = Number(this.info.spouseHeightMin);
      submitData.spouseHeightMax = Number(this.info.spouseHeightMax);
      submitData.spouseEducation = Number(this.info.spouseEducation);
      delete submitData.selectedPersonalityTags;
      delete submitData.selectedSpouseTags;
      submitPersonInfo(submitData).then(async res => {
        if (res.code === 20000) {
          sessionStorage.removeItem("joinFormData");
          Toast.success({
            //message:"您好，已收到您的入会申请，请等待审核通过后，即可登录会员中心",
            message: `入会申请已提交：您的编号是：${res.data.serialNumber}`,
            className: "createSuccessInfo"
          });
          this.$store.dispatch("SetToken", res.data.token).then(async () => {
            const token = res.data.token;
            const payload = JSON.parse(atob(token.split(".")[1]));
            const memberId = payload.nameid;

            if (
              this.info.selectedPersonalityTags &&
              this.info.selectedPersonalityTags.length > 0
            ) {
              const tags = this.info.selectedPersonalityTags.map(tag => ({
                tagId: tag.tagId || null,
                customTagName: tag.tagId
                  ? null
                  : tag.customTagName || tag.tagName || tag
              }));
              await savePersonalityTags({ memberInfoId: memberId, tags });
            }
            if (
              this.info.selectedSpouseTags &&
              this.info.selectedSpouseTags.length > 0
            ) {
              const tags = this.info.selectedSpouseTags.map(tag => ({
                tagId: tag.tagId || null,
                customTagName: tag.tagId
                  ? null
                  : tag.customTagName || tag.tagName || tag
              }));
              await saveSpouseRequirementTags({ memberInfoId: memberId, tags });
            }

            this.$store.dispatch("GetInfo", true).then(() => {
              this.customerServiceRemark = this.getCustomerServiceRemark({
                serialNumber: res.data.serialNumber,
                name: res.data.name
              });
              this.serialNumber = res.data.serialNumber;
              this.customerServicePopupVisible = true;
            });
          });
        } else {
          Toast.fail({ message: "提交失败" });
        }
      });
    },
    onFinish(values) {
      this.areaCheck = false;
      let hometown = values
        .filter(v => v)
        .map(v => v.name)
        .join("/");
      this.info.hometown = hometown;
    },
    showRegistrationTerms() {
      this.registrationTermsVisible = true;
    },
    getBasicStepNumber(step) {
      let actualStep = step;
      if (this.info.isAtl === "2" && step >= 3) {
        actualStep -= 1;
      }
      if (this.info.isAtl === "1" && step >= 27) {
        actualStep -= 1;
      }
      return actualStep;
    },
    employeeNoChange() {
      getEmployeeInfoByEmployeeNo(this.info.employeeNo).then(res => {
        if (res) {
          this.info.employeeNo = res.employeeNo;
          this.info.name = res.name;
          var entryDate = res.joinDate;
          if (entryDate) {
            entryDate = entryDate.substr(0, 7);
          }
          this.info.entryDate = entryDate;
          this.info.department = res.orgl1Name;
          this.info.positionTitle = res.titleName;
          this.info.companyName = 'ATL';
        } else {
          Toast({ message: '该工号不存在' });
        }
      })
    }
  },
    watch: {
      // 选择性别后，择偶性别默认设为异性：男(1)→女(2)，女(2)→男(1)
      "info.sex"(val) {
        if (val === "1" || val === "2") {
          this.info.spouseSex = val === "1" ? "2" : "1";
        }
      }
    },

  computed: {
    isAtl2() {
      return this.COMPANYNAME == "ATL";
    },
    filteredMatchmakers() {
      if (!this.matchmakerSearchText) {
        return this.allMatchmakers;
      }
      const keyword = this.matchmakerSearchText.toLowerCase();
      return this.allMatchmakers.filter(item =>
        (item.name || "").toLowerCase().includes(keyword)
      );
    }
  },
  created() {
    this.loadAllMatchmakers();
    const formData = sessionStorage.getItem("joinFormData");
    if (!formData) {
      let data = getOaInfo();
      if (data) {
        this.disabled = true;
        this.info.isAtl = "1";
        this.info.birthday = data.birthDate ? data.birthDate.substr(0, 7) : "";
        this.info.name = data.name;
        this.info.department = data.organizationName;
        this.info.employeeNo = data.userName;
        this.info.entryDate = data.entryDate ? data.entryDate.substr(0, 7) : "";
        this.info.positionTitle = data.position;
        this.info.sex = data.gender === "男" ? "1" : "2";
        // 择偶性别默认为异性：男(1)→女(2)，女(2)→男(1)
        this.info.spouseSex = this.info.sex === "1" ? "2" : "1";
        this.info.graduateSchool = data.graduatedSchool;
        this.info.companyName = this.COMPANYNAME;
        let education = "5";
        switch (data.highestEducation) {
          case "大学本科":
            education = "2";
            break;
          case "大学专科":
            education = "1";
            break;
          case "硕士":
            education = "3";
            break;
          case "博士":
            education = "4";
            break;
        }
        this.info.education = education;
      }
    }
    this.loadSelectedTags();
    this.loadFormData();
    // 设置日期滚轮默认值：OA已填充则同步滚轮，否则保留data()默认值
    if (this.info.entryDate) {
      const [entryYear, entryMonth] = this.info.entryDate.split('-');
      this.entryDate = new Date(Number(entryYear), Number(entryMonth) - 1, 1);
    }
    if (this.info.birthday) {
      const [birthYear, birthMonth] = this.info.birthday.split('-');
      this.birthday = new Date(Number(birthYear), Number(birthMonth) - 1, 1);
    }
    // 从路由query读取微信openid（OA免登流程带入，覆盖缓存值）
    const openid = this.$route.query.openid;
    if (openid) {
      this.info.weChatOpenId = openid;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/tagSelector") {
      this.saveFormData();
    } else {
      sessionStorage.removeItem("joinFormData");
      localStorage.removeItem("selectedTags");
    }
    next();
  },
  beforeDestroy() {
    // 微信用户信息缓存已废弃，不再存储
  }
};
</script>
<style scoped lang="less" src="../style/joinMatchmakerTeam.less" />



// WEBPACK FOOTER //
// src/views/joinMatchmakerTeam.vue